import View from '@hfe/max-view';
import CalendarDayItem from './CalendarDayItem';
import { createElement, memo } from '@max/max';
import '../../../index.scss';
import '../calendar.scss';
const CalendarDaysBody = ({ calendarState, viewState, holidayState, onSyncSelection, onSyncStorage, isShowDawnTooltip }) => {
    // 一个月的第一天特殊处理，要额外返回前面几个格子
    const firstDay = calendarState.values[0];
    const emptyBlock = new Array(firstDay.weekday).fill(0);
    const syncSelection = value => {
        onSyncSelection(value);
    };
    return <View className="calendar-days-body-container">
      {emptyBlock && emptyBlock.map((item, index) => {
        return <CalendarDayItem value={''} key={`empty${index}`}/>;
    })}
      {calendarState.values.map((item, index) => {
        return <CalendarDayItem value={item} key={item.indexKey} order={1 + index + ((emptyBlock === null || emptyBlock === void 0 ? void 0 : emptyBlock.length) || 0)} viewState={viewState} holidayState={holidayState} onSyncSelection={syncSelection} onSyncStorage={onSyncStorage} isShowDawnTooltip={isShowDawnTooltip}/>;
    })}
    </View>;
};
export default memo(CalendarDaysBody);
